import React from 'react';
import logoSAWbw from './SAW-Logo_grau-negativ_RGB.svg';
import { defineMessages, useIntl } from 'react-intl';
import { Container as SemanticContainer } from 'semantic-ui-react';
import config from '@plone/volto/registry';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import Icon from '@plone/volto/components/theme/Icon/Icon';
import linkedInIcon from '../../icons/linkedin.svg';
import youtubeIcon from '../../icons/youtube.svg';
import instagramIcon from '../../icons/instagram.svg';
import blueskyIcon from '../../icons/bluesky.svg';

const messages = defineMessages({
    FindUsOn: {
        id: 'Find us on',
        defaultMessage:
            'Find us on',
    },
});

const preFooter = (props) => {
    const intl = useIntl();
    const animate = false
    const iconSize = '32px';
    const Container =
        config.getComponent({ name: 'Container' }).component || SemanticContainer;

    return (
        <Container className="layout saw-pre-footer">
            <img src={logoSAWbw} alt="SAW logo" className='logo-footer' />
            <div className='social-media-wrapper'>
                {intl.formatMessage(messages.FindUsOn)}
                <ul className="social-media-content">
                    <li className='item'>
                        <UniversalLink
                            title='linkedin'
                            href="https://www.linkedin.com/company/105784840/"
                            openLinkInNewTab
                            className='social-network item linkedin animate'
                            rel={'me'}
                        >
                            LinkedIn
                            <Icon
                                className='socialmedia-icon'
                                name={linkedInIcon}
                                size={iconSize}
                                title='linkedin'
                            />
                        </UniversalLink>
                    </li>
                    <li className='item'>
                        <UniversalLink
                            title='youtube'
                            href="https://www.youtube.com/@saw-leipzig"
                            openLinkInNewTab
                            className='social-network item youtube animate'
                            rel={'me'}
                        >
                            Youtube
                            <Icon
                                className='socialmedia-icon'
                                name={youtubeIcon}
                                size={iconSize}
                                title='youtube'
                            />
                        </UniversalLink>
                    </li>
                    <li className='item'>
                        <UniversalLink
                            title='instagram'
                            href="https://www.instagram.com/saw_leipzig/"
                            openLinkInNewTab
                            className='social-network item instagram animate'
                            rel={'me'}
                        >
                            Instagram
                            <Icon
                                className='socialmedia-icon'
                                name={instagramIcon}
                                size={iconSize}
                                title='instagram'
                            />
                        </UniversalLink>
                    </li>
                    <li className='item'>
                        <UniversalLink
                            title='bluesky'
                            href="https://bsky.app/profile/saw-leipzig-1846.bsky.social"
                            openLinkInNewTab
                            className='social-network item bluesky animate'
                            rel={'me'}
                        >
                            Bluesky
                            <Icon
                                className='socialmedia-icon'
                                name={blueskyIcon}
                                size={iconSize}
                                title='bluesky'

                            />
                        </UniversalLink>
                    </li>
                </ul>
            </div>

        </Container>
    );
}

export default preFooter;